<template>
    <span>
    <span v-for="event in todayEvents" v-bind:key="event.title" :style="{'background-color': event.color }"  :class="event.class" :title="event.title"></span>
    </span>
</template>

<script>
    export default {
        name: "KappKalenderEvent",
        props : [ 'events', 'tstamp' ],
        data ( ) {
            return {
                // foundEvents : []
            }
        },
        computed : {
            todayEvents : function ( ) {

                let todayEvents = this.events;

                if( this.events.length ) {

                    let today =  new Date();
                    today.setTime(this.tstamp * 1000);

                    todayEvents.map(function (evt) {
                        evt.class = ['event'];

                        let start = new Date(evt.start * 1000);
                        let end = new Date(evt.end * 1000);

                        if( start.isBefore( today, 'day' ) ) evt.class.push( 'event--before' );
	                    if( end.isAfter( today, 'day' ) ) evt.class.push( 'event--after' );

                    }, today);

                }
                return todayEvents;
            }
        }
    }
</script>

<style scoped>

    .event {
        position: absolute;
        top : 14px;
        left: 50%;
        width: 12px;
        height: 4px;
        margin-left: -6px;
        background-color: #2AFF35;
        border-radius: 2px;
        z-index: 5;
    }

    .event:nth-child(2) {
        top: 9px;
    }

    .event:nth-child(3) {
        top: 4px;
    }


    .event--before {
        left: 0;
        width: 50%;
        width: calc( 50% + 7px );
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        margin-left:0;
    }
    .event--after {
        right: 0;
        width: 50%;
        width: calc( 50% + 7px );
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    .event--before.event--after {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/subparts/KappKalenderEvent.vue